<script setup>
import { defineModel, defineEmits, computed, defineProps }  from 'vue'
import GoogleSheetsLogoSvg from "@/components/UI/svg/GoogleSheetsLogoSvg.vue";
import GoogleDriveBrandingSvg from "@/components/UI/svg/GoogleDriveBrandingSvg.vue";
import NewTabSvg from "@/components/UI/svg/NewTabSvg.vue";
import FileSelectFull from "@/components/Connection/FileSelectFull.vue";
import {isEmpty} from "@/service/utils";


const file = defineModel('file')


const emits = defineEmits(['reload-tabs', 'open-modal', 'delete-item', 'save-files'])


const props = defineProps({
    index: {
        type: Number,
        required: true,
    }
})


function toggleSelect() {
    file.value.isToggle = !file.value.isToggle
}

function openSpreadSheetInNewTab() {
    let url = "https://docs.google.com/spreadsheets/d/" + file.value.id + "/edit?gid=" + file.value.tab.sheetId
    window.open(url, '_blank')
}

function openModal() {
    emits('open-modal')
}

function reloadTabs(spreadsheet_id, tab) {
    emits("reload-tabs", spreadsheet_id, tab)
}

const isFileTabIsEmpty = computed(() => {
    return isEmpty(file.value.tab);
})

function deleteItem(value) {
    emits("delete-item", value)
}

function saveItem() {
    file.value.isToggle = true
}

function saveFiles(files) {
    emits('save-files', files, props.index)
}


</script>

<template>
    <div class="w-full">
        <div
            v-on:click="toggleSelect"
            v-show="file.isToggle"
            class="w-full h-20 flex items-center justify-between border-b border-gray-200 hover:bg-gray-100 px-10 cursor-pointer"
        >
            <div class="flex items-center w-1/3 px-10">
                <GoogleSheetsLogoSvg class="size-6 mr-4"/>
                <div class="truncate">
                    <div class="font-bold text-sm text-gray-600 ">Файл</div>
                    <div class="text-sm text-gray-600">{{ file?.name }}</div>
                </div>
            </div>
            <div class="w-1/3 px-4">
                <div class="font-bold text-sm text-gray-600 ">Вкладка</div>
                <div v-if="!isFileTabIsEmpty" class="text-sm text-gray-600">{{ file?.tab.sheetTitle }}</div>
                <div v-else class="text-sm text-gray-600">Вкладка загружается...</div>
            </div>
            <div class="flex items-center justify-center gap-4 w-1/3">
                <GoogleDriveBrandingSvg class="size-6"/>
                <div
                    class="flex items-center justify-center size-10 rounded-full duration-150  transition-all hover:bg-gray-200"
                    v-on:click.stop="openSpreadSheetInNewTab"
                >
                    <NewTabSvg
                        class="size-6 fill-gray-600"
                    />
                </div>
            </div>
        </div>
        <div
            v-show="!file.isToggle"
            class="w-full flex flex-col justify-center items-center mt-10"
        >
            <FileSelectFull
                v-model:file="file"
                @reload-tabs="reloadTabs"
                @open-modal="openModal"
                @delete-item="deleteItem"
                @save-item="saveItem"
                @saveFiles="saveFiles"
                :is-source="false"
            />
        </div>
    </div>

</template>

<style scoped>

</style>